import * as React from 'react'
import { toast } from 'react-toastify'
import Button from 'ui/atoms/Button'
import Flex from 'ui/atoms/Flex'
import { ZentakeContext } from 'utils/ZentakeContext'

import KioskModeModal from './KioskModeModal'
import TabBody from './TabBody'

function TabletsTab() {
  const { userDetails } = React.useContext(ZentakeContext)
  const [isKioskModalOpen, setIsKioskModalOpen] = React.useState(false)

  const goToTabletMode = React.useCallback(() => {
    if (!userDetails?.is_verified) {
      toast.warning('Verify Email')
    } else {
      window.open('/t', '_blank')
    }
  }, [userDetails?.is_verified])

  return (
    <>
      <TabBody>
        <Flex $horizontalSpacing="large">
          <Button $primary onClick={goToTabletMode}>
            Launch Tablet Mode
          </Button>

          <Button $primary onClick={() => setIsKioskModalOpen(true)}>
            Launch Kiosk Mode
          </Button>
        </Flex>
      </TabBody>
      {isKioskModalOpen && (
        <KioskModeModal onClose={() => setIsKioskModalOpen(false)} />
      )}
    </>
  )
}

export default TabletsTab
